var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"card"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{class:_vm.status},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }